;(function ( $ ) {

    /**
     *  Get and set inherited data from backend source
     *
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'getInheritedData';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {

        init: function () {

            var $el = $(this.element),
                inheritedSalutation = $el.find('[name="inherited_salutation"]').val(),
                inheritedTitle = $el.find('[name="inherited_title"]').val(),
                inheritedFirstName = $el.find('[name="inherited_first_name"]').val(),
                inheritedLastName = $el.find('[name="inherited_last_name"]').val(),
                inheritedCompany = $el.find('[name="inherited_company"]').val(),
                inheritedCountry = $el.find('[name="inherited_country"]').val(),
                inheritedEmail = $el.find('[name="inherited_email"]').val();

            $('select[name="salutation"]').val(inheritedSalutation).trigger("change");
			$('select[name="title"]').val(inheritedTitle).trigger("change");
            $('input[name="givenname"]').val(inheritedFirstName).trigger("change");
            $('input[name="surname"]').val(inheritedLastName).trigger("change");
			$('input[name="company"]').val(inheritedCompany).trigger("change");
			$('select[name="country"]').val(inheritedCountry).trigger("change");
			$('input[name="email"]').val(inheritedEmail).trigger("change");

        }

    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
